module.exports = __webpack_public_path__ + "static/media/download tvOS.8d7bcdcb.svg";